import(/* webpackMode: "eager" */ "/workspace/online-customer-service-fe/app/global-error.tsx");
